/*eslint-disable*/
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// actions
import { gatewayRequestAxios } from '../../services/interceptor'
import { GATEWAY_API_BULK_USER_STATUS_URL } from '../../constants/urls'

const initialState = {
    status: 'idle',
    error: null,
    bulkStatuses: [], // array of objects, each object represents a single bulk upload req + status associated w/ user
}

const getParamsForGetBulkStatuses = filter => {
  const params = {limit: 500}
  const { fileName } = filter;
  if(fileName) {
      params.fileName = fileName;
  }
  return params
}

export const getBulkStatuses = createAsyncThunk('uploadRequests/getBulkStatuses', async(filter) => {
    const { fileName } = filter;
    const response = await gatewayRequestAxios.get(`${GATEWAY_API_BULK_USER_STATUS_URL}/${fileName}`)
    return response.data
})

export const uploadStatusSlice = createSlice({
    name: 'uploadStatus',
    initialState,
    
    reducers: {
      resetBulkStatuses: (state) => {
        state.bulkStatuses = []
      },
    },
    extraReducers(builder) {
      builder
        .addCase(getBulkStatuses.pending, (state) => {
          state.status = 'loading'
          state.error = undefined
        })
        .addCase(getBulkStatuses.fulfilled, (state, action) => {
          state.status = 'succeeded'
          state.error = undefined
          state.bulkStatuses =action.payload.jobStatus
          // console.log(state.bulkStatuses);
          // console.log("pr");
        })
        .addCase(getBulkStatuses.rejected, (state, action) => {
          state.status = 'failed'
          state.error = action.error.message
        })
    }
  })

  export const { resetBulkStatuses } = uploadStatusSlice.actions

  export default uploadStatusSlice.reducer;

